import * as React from "react";
import MuiTextField, { type TextFieldProps as MuiTextFieldProps } from "@mui/material/TextField";

import { cn } from "../../lib/utils";

export type TextFieldProps = MuiTextFieldProps & {
  containerClassName?: string;
  inputClassName?: string;
};

const textFieldSx = {
  "& .MuiOutlinedInput-root": {
    minHeight: 40,
    maxHeight: 40,
    borderRadius: "0.375rem",
    backgroundColor: "#fff",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E2E8F0",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CBD5E1",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#00BC7D",
    borderWidth: "1px",
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    boxShadow: "0 0 0 1px #00BC7D",
  },
  "& .MuiInputBase-input": {
    minHeight: "40px !important",
    fontFamily: "Nunito",
    boxSizing: "border-box",
    paddingTop: "0 !important",
    paddingBottom: "0 !important",
    fontSize: "0.875rem !important",
  },
  "& .MuiInputBase-inputMultiline": {
    fontSize: "0.875rem !important",
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    marginTop: "6px",
  },
  "& .MuiInputLabel-root": {
    color: "#64748B",
  },
};

const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (
    {
      className,
      containerClassName,
      inputClassName,
      sx,
      slotProps,
      variant = "outlined",
      ...props
    },
    ref,
  ) => {
    const htmlInputSlot = slotProps?.htmlInput as { className?: string } | undefined;

    return (
      <MuiTextField
        {...props}
        ref={ref}
        variant={variant}
        className={cn(containerClassName, className)}
        sx={{
          ...textFieldSx,
          ...sx,
        }}
        slotProps={{
          ...slotProps,
          htmlInput: {
            ...(htmlInputSlot || {}),
            className: cn("!text-sm !leading-4", htmlInputSlot?.className, inputClassName),
          },
        }}
      />
    );
  },
);

TextField.displayName = "TextField";

export { TextField };
